module.exports = __webpack_public_path__ + "static/0cbf56b713c8c6e67ee0babc242c23de257d51f96a9d0144b53fb01108d350a8-3f9ce708707094580fb85bca5867e606.jpeg";